let ChildActivity = Backbone.Model.extend(
    {
        defaults:
            {
                name: null,
                days: [],
                hours: 0,
                selected: false,
            },

        getName: function () {
            return this.get('name');
        },

        getDays: function () {
            return this.get('days');
        },

        getHours: function () {
            return this.get('hours');
        },

        isSelected: function () {
            return this.get('selected');
        },

        setDays: function (days) {
            this.set('days', days);
        },

        setHours: function (hours) {
            this.set('hours', parseInt(hours))
        },

        setSelected: function (isSelected) {
            this.set('selected', isSelected);
        },

        createFromConfig: function (config) {
            this.set('name', config.name);
            this.setDays(populateNDaysAWeek(config.days));
            this.setHours(config.hours)
            this.config = config;
            return this;
        },

        loadIn: function (childActivityList) {
            let thisObj = this;
            let match = childActivityList.find(function (x) {
                return x.getName() === thisObj.getName();
            });
            if (match !== undefined) {
                this.setSelected(match.isSelected());
                this.setHours(match.getHours());
                this.setDays(match.getDays());
            }
            return this;
        },

        getAfterWorkHours: function () {
            if(this.getHours() !== 0) {
                return this.getHours();
            }
            return this.config.afterWorkHrs;
        },
        getDaysAWeek: function () {
            return this.getDays().length;
        }
    }
);

function CreateChildActivity(attributes) {
    return new ChildActivity(attributes);
}

let ChildActivityList = Backbone.Collection.extend(
    {
        model: ChildActivity
    }
);
